import type {
  PortfolioDividendDataRaw,
  DemoPortfolioDividendDataRaw,
} from '../hooks/usePortfolioDividend';

const isDemoPortfolioData = (
  obj?: PortfolioDividendDataRaw
): obj is DemoPortfolioDividendDataRaw => {
  if (!obj) {
    return false;
  }
  return 'samplePortfolio' in obj;
};

export const choosePortfolioData = (rawResponse?: PortfolioDividendDataRaw) => {
  if (isDemoPortfolioData(rawResponse)) {
    return rawResponse?.samplePortfolio;
  }
  return rawResponse?.Portfolio;
};
